import { shallow } from 'zustand/shallow'
import { useAddCartItem } from '@/features/cart/hooks/useAddCartItem'
import { useRecentlyAddedProducts } from '@/features/cart/hooks/useRecentlyAddedProducts'
import { ShopifySectionComponent } from '@/types/ShopifySectionComponent'
import { Button, ChoiceChips, Icon, Text } from '@lounge-fe/ui-kit'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ProductQuickAddBlockData } from './types'

const ProductQuickAddBlock: ShopifySectionComponent<
  ProductQuickAddBlockData
> = ({ data }) => {
  const { variants = [], label, stop_selling_quantity = 0 } = data || {}
  const [selectedVariantId, setSelectedVariantId] = useState<string>()
  const { t } = useTranslation()

  const addItem = useAddCartItem()
  const recentlyAddedProductIds = useRecentlyAddedProducts(
    (state) => state.recentlyAddedProductIds,
    shallow,
  )

  return (
    <div>
      {label && (
        <Text as="label" className="mb-2 font-regular block">
          {label}
        </Text>
      )}
      <ChoiceChips
        className="grid grid-cols-[repeat(auto-fit,minmax(min(100%/2,max(64px,100%/5)),1fr))]"
        value={selectedVariantId}
        onChange={(value: string | undefined) => setSelectedVariantId(value)}
      >
        {variants.map((option) => (
          <ChoiceChips.Item
            key={option.id}
            value={option.id.toString()}
            disabled={
              Boolean(option.inventory_management) &&
              option.inventory_policy === 'deny' &&
              option.inventory_quantity - stop_selling_quantity <= 0
            }
            className="flex items-center justify-center h-12"
          >
            {option.title}
          </ChoiceChips.Item>
        ))}
      </ChoiceChips>
      <Button
        className="w-full mt-6"
        disabled={!selectedVariantId}
        onClick={() =>
          addItem.mutate({ id: Number(selectedVariantId!), quantity: 1 })
        }
        isLoading={addItem.isPending}
        size="md"
      >
        {recentlyAddedProductIds.includes(Number(selectedVariantId!)) ? (
          <span className="bg-white flex rounded-circle p-2 w-6 h-6">
            <Icon.Check className="!text-black max-w-full" />
          </span>
        ) : (
          data?.button_text || t('product.add_to_bag')
        )}
      </Button>
    </div>
  )
}

export default ProductQuickAddBlock
